import { AutoMap } from "@automapper/classes";
import { Entity } from "../base/entity.model";

export class ReferenceClassifications extends Entity {

    @AutoMap()
  public description!: string;

    @AutoMap()
    public code!: string;

}